<template>
    <div>
        <basic-container>
        <el-form ref="formRef" inline label-width="80px" size="small">

                <el-form-item label="项目名称">
                    <el-select
                    v-model="query.projectId"
                    placeholder="请选择项目名称"
                    @change="projectChange"
                    style="width: 100%"
                    >
                    <el-option
                        v-for="(item, index) in projectList"
                        :key="index"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="合同编号" prop="code">
                    <el-input show-word-limit style="width: 100%" placeholder="请输入合同编号" v-model="query.code" clearable maxlength="50" />
                </el-form-item>

                <el-form-item label="结算日期" prop="timeRange" >
                    <el-date-picker
                    style="width: 100%"
                    clearable
                    v-model="query.timeRange"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="结算金额">
                    <div style="display:flex;">
                        <el-input  clearable  placeholder="请输入结算金额"  v-model="query.payAmountStart "  maxlength="12"
                        />-
                            <el-input clearable placeholder="请输入结算金额" v-model="query.payAmountEnd " maxlength="12" />
                    </div>

                </el-form-item>

                <el-form-item label-width="100px" label="供应商名称">
                    <el-input style="width: 100%" placeholder="请输入供应商名称" v-model="query.partnerName" maxlength="50"
                     clearable   show-word-limit />
                </el-form-item>

                <div class="btnArea">
                  <el-button type="primary" @click="searchSettlement" size="small"> 搜索 </el-button>
                <el-button @click="searchClear" size="small"> 清空 </el-button>
                </div>

        </el-form>
        <avue-crud
            :option="option"
            :table-loading="loading"
            :data="settlementList"
            :page.sync="page"
            v-model="selectForm"
            ref="crud"
            @on-load="onLoad"
            @current-change="currentChange"
            @search-reset="searchReset"
            @selection-change="selectionChange"
            @size-change="sizeChange"
            @refresh-change="onLoad">
             <template slot="menuLeft">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="addConstract"> 新 增</el-button>
            <!-- <el-button type="primary" @click="delConstractInvoice">删除</el-button> -->
            </template>
            <template slot-scope="scope" slot="payAmount">
                <div class="money"><span>{{tool.money_format_allowvoid(scope.row.payAmount)  }}</span></div>
            </template>
            <template slot-scope="scope" slot="menu">
            <el-button
                type="text"
                size="small"
                icon="el-icon-tickets"
                @click="checkSettlementRecord(scope.row)"
                >查看
            </el-button>
            <el-button
                type="text"
                size="small"
                icon="el-icon-edit"
                v-if='scope.row.lifecycleIndex!=3&&scope.row.lifecycleIndex!=5'
                @click="editSettlementRecord(scope.row)"
                >编辑
            </el-button>
            <el-button
                type="text"
                size="small"
                icon="el-icon-delete"
                v-if='scope.row.lifecycleIndex!=3&&scope.row.lifecycleIndex!=5'
                @click="removeSettlementRecord(scope.row.id)"
                >删除
            </el-button>
            </template>
        </avue-crud>
        <el-dialog
          :title="dialogTitle"
          v-if="addOrEditOrWatchFlag"
          :visible.sync="addOrEditOrWatchFlag"
          width="40%"
          append-to-body="true"
          :before-close="handleClose"
          :close-on-click-modal="false">
          <!-- <invoiceDetail></invoiceDetail> -->
          <recordDetail :projectId='this.query.projectId' @close='handleClose' :form='settleDetail' @submitInfo="submitInfo" :operateStatus='operateStatus'>
          </recordDetail>
        </el-dialog>

        </basic-container>
    </div>
</template>

<script>
import { getProjectList } from '@/api/crmedical/project/project';
  import {paymentrecordImg
} from '@/api/crmedical/contract/execution';
import { getContractSettlementList ,editContracInvoiceRecordDetail,
addContractSettlement ,getContracInvoiceRecordDetail ,removeContracInvoiceRecordDetail} from '@/api/crmedical/contract/contractSettlement';
import recordDetail from '@/components/contract/record'
import invoiceDetail from '@/components/contract/invoice'
export default {
    components:{recordDetail,invoiceDetail},
  data() {
    return {
      dialogTitle:'',
      operateStatus:false,//1新增，2编辑，3查看
      addOrEditOrWatchFlag:false,//编辑新增查看的dialog
      settleDetail:{},
      isEdit:false,
      loading:false,
      option: {
        index: true,
        // selection: true,reserveSelection:true,
        indexLabel: '序号',
        page: true,
        align: 'center',
        menuAlign: 'center',
        addBtn:false,
        editBtn: false,
        delBtn: false,
        border:true,
        dialogClickModal: false,
        column: [
          {
            label: '项目名称',
            prop: 'projectName',
          },
          {
            label: '合同名称',
            prop: 'contractName',
          },
          {
            label: '合同编号',
            prop: 'code',
          },
          {
            label: '供应商名称',
            prop: 'partnerName',
          },
          {
            label: '结算金额',
            prop: 'payAmount',
            align:'center',
            slot: true,
          },
          {
            label: '结算日期',
            prop: 'payTime',
            format: 'yyyy-MM-dd',
            type: 'date',
          },

          {
            label: '备注',
            prop: 'remark',
          },
        ],
      },
      timeRange:[],
      query: {
        payAmountStart:'',
        payAmountEnd:'',
        timeStart:'',
        timeEnd:'',
        timeRange:[]
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      settlementList:[],
      form: {},
      projectList: [], //部门list,
      projectId:'',
      selectIds:''
    };
  },
  created() {
    getProjectList().then((res) => {
      this.projectList = res.data;
      if (this.projectList.length > 0) {
        this.$set(this.query, 'projectId', this.projectList[0].id);
       this.onLoad()
      }
    });
  },
  methods: {
    dialogClose(){
      this.addOrEditOrWatchFlag = false
    },
    sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
    currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
    //批量删除
    delConstracts(){
       this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            let ids = this.selectIds.toString()
             removeContracInvoiceRecordDetail(ids).then(()=>{
              this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.onLoad()
          })
        })
    },
    //表格多选
    selectionChange(val){
      this.selectIds = []
      val.forEach(element => {
        this.selectIds.push(element.id)
      });
    },
    searchClear(){
      // this.$refs['formRef'].resetFields()
      this.query = {
        timeStart:'',
        payAmountStart:'',
        payAmountEnd:'',
        timeEnd:'',
        timeRange:[],
        code:'',
        projectId:'',
        partnerName:''
      }
      this.$set(this.query, 'projectId', this.projectList[0].id);
    },
    handleClose(){
      this.settleDetail = {}
      this.addOrEditOrWatchFlag = false
    },
    removeSettlementRecord(id){

      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

             removeContracInvoiceRecordDetail(id).then(()=>{
              this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.onLoad()
          })



        })
    },
    searchSettlement(){
      this.page.currentPage =1
       let reg = /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/;

      if ((this.query.payAmountStart==''&&this.query.payAmountEnd=='')||(reg.test(this.query.payAmountStart)&&reg.test(this.query.payAmountEnd))) {
        if(this.query.payAmountStart>this.query.payAmountEnd){
          //大金额在后面
          let transfromNum = this.query.payAmountEnd
          this.query.payAmountEnd = this.query.payAmountStart
          this.query.payAmountStart = transfromNum
        }
        console.log(this.query.timeRange)
        if(this.query.timeRange&&this.query.timeRange.length>0){
            this.query.timeStart = this.query.timeRange[0]
            this.query.timeEnd = this.query.timeRange[1]
        }else{
            this.query.timeRange = []
             this.query.timeStart = ''
              this.query.timeEnd = ''
        }

        this.page.currentPage = 1
        this.onLoad()
      } else {
        let sum = Number(this.query.payAmountStart)  + Number(this.query.payAmountEnd)
         if(sum == this.query.payAmountStart||sum == this.query.payAmountEnd){
           this.$message.error('请输入一个金额范围');
         }else{
           this.$message.error('金额格式不正确，请输入小数点前9位，后2位');
         }
      }
    },
    //编辑记录
    editSettlementRecord(row){
      this.dialogTitle = '编辑结算记录'
       this.operateStatus = true
       this.isEdit = true
       this.addOrEditOrWatchFlag = true
       getContracInvoiceRecordDetail(row.id).then(({data})=>{
         this.settleDetail = data
         this.settleDetail.name = row.contractName
         this.settleDetail.code = row.code
         this.settleDetail.partnerName = row.partnerName
         this.settleDetail.id = row.id
         paymentrecordImg({mainId:row.id}).then(({data})=>{
          this.settleDetail.attachList = data

        })

       })
    },
    //查看记录
    checkSettlementRecord(row){
      this.dialogTitle = '查看结算记录'
      this.operateStatus = false
       this.addOrEditOrWatchFlag = true
       getContracInvoiceRecordDetail(row.id).then(({data})=>{
         this.settleDetail = data
         this.settleDetail.name = row.contractName
         this.settleDetail.code = row.code
         this.settleDetail.partnerName = row.partnerName
         this.settleDetail.id = row.contractId
         paymentrecordImg({mainId:row.id}).then(({data})=>{
          this.settleDetail.attachList = data

        })
       })
    },
    //新增结算记录
    addConstract(){
     this.settleDetail = {}
       this.dialogTitle = '新增结算记录'
      this.$nextTick(()=>{
        this.$set(this,'projectId', this.query.projectId);
        this.operateStatus = true
        this.addOrEditOrWatchFlag = true
      })


    },
    //提交信息
    submitInfo(val){

        if(this.isEdit){
          this.isEdit = false
          editContracInvoiceRecordDetail(val).then(()=>{
            this.$message({
              type: 'success',
              message: '提交成功!'
            });
            this.onLoad()
            this.addOrEditOrWatchFlag = false
          })
        }else{
          addContractSettlement(val).then(()=>{
           this.$message({
              type: 'success',
              message: '提交成功!'
            });
            this.settleDetail = {}
            this.onLoad()
            this.addOrEditOrWatchFlag = false
            })
        }

        console.log('提交信息',val)
    },
    initData(){

    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
       getContractSettlementList(Object.assign({},{ current: this.page.currentPage, size: this.page.pageSize }, this.query)).then(({data})=>{
          this.settlementList = data.records
          this.page.total = data.total
          this.loading = false;
        })
    },
  },
};
</script>

<style lang="scss" scoped>
.boardList {
}
.form {
  display: flex;
}
.btnArea{
  width: 128px;
    float: right;
    margin-right: 56px;
}
::v-deep .avue-crud .el-form-item {
  display: block;
}
.money{
  text-align: right;
}
</style>
